import { ColorTheme } from '../partials/palette.css';
import { ColorTheme as RawColorProps } from '@/__generated__/graphql';

export const useColorTheme = (props?: RawColorProps | null) => {
  const label = (props?.label ?? undefined) as ColorTheme;

  return label;
};
